<template>
  <span class="leading-relaxed font-bold text-green-300 tracking-tight text-3xl">
    {{title}}
  </span>
</template>

<script>
export default {
  name: "StepTitle",
  props: ['title']
}
</script>

<style scoped>

</style>
